import { render, staticRenderFns } from "./device_stats.vue?vue&type=template&id=1c29547a&scoped=true&"
import script from "./device_stats.vue?vue&type=script&lang=js&"
export * from "./device_stats.vue?vue&type=script&lang=js&"
import style0 from "./device_stats.vue?vue&type=style&index=0&id=1c29547a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c29547a",
  null
  
)

export default component.exports